﻿'use strict'
import { App, Action } from '../../config/app.js'
import { i18n, flattenObject } from '../../helper.js'

const OrderExport =
{
	confirmAgreement: async (agree, options) =>
	{
		if (!agree)
			return
		const guid = Handlebars.helpers.currentUser().id
		const res = await fetch(`${location.origin}${App.Store.options.baseUrl}/customer/${guid}/attribute`, {
			method: 'POST',
			body: JSON.stringify({
				data: {
					id: 'AgreeToExportOrders',
					value: true
				}
			})
		})
		if (res.status !== 200)
			return OrderExport.throwFileDownloadError()
		Handlebars.helpers.currentUser().sync({
			attributes: {
				agreeToExportOrders: true
			}
		})
		OrderExport.downloadReport(options)
	},
	downloadReport: async options =>
	{
		const query = flattenObject(options)
		const url = new URL(`${location.origin}${App.Store.options.baseUrl}/orderreport`)
		for (let key in query)
			url.searchParams.append(key, query[key])

		const res = await fetch(url.toString())
		if (res.status !== 200)
			throw new Error('Export failed') // This should get the error from the response
		const csvData = await res.text()
		const csvLink = document.createElement('a')
		csvLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvData)
		csvLink.target = '_blank'
		csvLink.download = (query['filter[pecom]'] === 'true' ? 'Pt' : '') + 'Orders_' +
			Handlebars.helpers.formatDate(new Date(), 'yyyyMMDD') + '(' +
			Handlebars.helpers.formatDate(query['filter[from]'], 'yyyyMMDD') + '-' +
			Handlebars.helpers.formatDate(query['filter[to]'], 'yyyyMMDD') + ',' +
			document.querySelector('select[name="filter[status]"] option[value="' + query['filter[status]'] + '"]').innerText +
			').csv'
		csvLink.click()
	},
	presentAgreement: async (options) =>
	{
		try
		{
			const topic = await App.Store.fetch('topic', 'Apex.Report.Terms')
			const modal = App.UI.Confirm(
				topic.attributes.body,
				agree => OrderExport.confirmAgreement(agree, options),
				{
					title: topic.attributes.title,
					size: 'large',
					scrollable: true,
					buttons: {
						confirm: {
							label: i18n('common.iagree')
						}
					}
				}
			)[0]
			const modalBody = modal.querySelector('.modal-body')
			const acceptBtn = modal.querySelector('.modal-footer .bootbox-accept')
			const scrollTolerance = 5
			const modalScroll = () =>
			{
				if (modalBody.scrollTop >= (modalBody.scrollHeight - modalBody.offsetHeight - scrollTolerance))
				{
					acceptBtn.disabled = false
					modalBody.removeEventListener('scroll', modalScroll)
					window.removeEventListener('resize', modalScroll)
				}					
			}
			if (modalBody.scrollTop <= (modalBody.scrollHeight - modalBody.offsetHeight - scrollTolerance))
			{
				acceptBtn.disabled = true
				modalBody.addEventListener('scroll', modalScroll)
				window.addEventListener('resize', modalScroll)
			}
		}
		catch (e)
		{
			App.Component.HandleErrors(e)
		}
	}
}


Action.create(
{
	name: 'order report export',
	handler: async function (resolve, reject, data)
	{
		try
		{
			await OrderExport.downloadReport(data)
		}
		catch (e)
		{
			reject(e)
		}

		return resolve(data)
	}
})

document.addEventListener('action.before', e =>
{
	if (e.detail.name == 'order report export' && !Handlebars.helpers.currentUser().attributes.agreeToExportOrders)
	{
		e.preventDefault() // Cancel action
		OrderExport.presentAgreement(e.detail.data)
	}
})

export default OrderExport
